import React from "react";
import { cn } from "../../Utils/helper";

const ProgressDot = ({
  index,
  currentStep,
  isReviewed = false,
  isErrorStep = false,
  hasAnswer = false,
  onClick,
}) => {
  const stepNumber = index + 1;
  const isCurrent = stepNumber === currentStep;

  let dotClass = "w-1.5 h-1.5";
  let dotColor = "";

  if (isReviewed && isErrorStep) {
    dotColor = "bg-[#EF4056] border-[#EF4056]";
  } else if (hasAnswer) {
    dotColor = "bg-[#08B89D] border-[#08B89D]";
  } else {
    dotColor = "bg-[#E9E6E4] border-[#E9E6E4]";
  }

  if (isCurrent) {
    dotClass = "w-4 h-4";
    dotColor += " border-4";
  } else {
    dotClass = "w-1.5 h-1.5";
    dotColor += " border-2";
  }

  return (
    <div
      className="flex items-center justify-center relative cursor-pointer"
      onClick={onClick}
    >
      <div
        className={cn(
          "rounded-full aspect-square transition-all duration-300",
          dotClass,
          dotColor
        )}
        draggable="false"
      />
    </div>
  );
};

export default ProgressDot;
